import { IconButton, Theme, Tooltip } from '@mui/material';

import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import CourseCatalog from '../../group/CourseCatalog';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { styled } from '@mui/system';
import styles from '../styles/CourseCatalogDialog.module.css';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [theme.breakpoints.up('xl')]: {
    '& .MuiDialog-paper': {
      width: '60%'
    }
  },
  [theme.breakpoints.between('md', 'lg')]: {
    '& .MuiDialog-paper': {
      width: '70%'
    }
  },
  [theme.breakpoints.between('sm', 'md')]: {
    '& .MuiDialog-paper': { width: '80%' }
  },
  [theme.breakpoints.down('xs')]: {
    '& .MuiDialog-paper': { margin: 8, width: '100%', maxWidth: '100%' }
  }
}));
interface CourseCatalogDialogProps {
  onClose: () => void;
}

function CourseCatalogDialog(props: CourseCatalogDialogProps) {
  return (
    <StyledDialog open maxWidth={false} fullWidth>
      <DialogTitle className={styles.dialogTitle}>
        Available Courses
        <div className={styles.iconButton}>
          <Tooltip title="Close dialog" placement="left">
            <IconButton onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent>
        <CourseCatalog />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => props.onClose()}
        >
          Close
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}

export default CourseCatalogDialog;
